import React from 'react';
import PropTypes from 'prop-types';

import ThemeContext from '../../context/ThemeContent/ThemeContext';
import { PUBLIC } from '../../constants/theme';
import { ThemedHeader } from '../Header/Header';
import { ThemedMain } from '../Main/Main';

export const PublicLayout = props => (
    <React.Fragment>
        <ThemeContext.Provider value={PUBLIC}>
            <ThemedHeader>
                {props.headerContent}
            </ThemedHeader>
            <ThemedMain>
                {props.mainContent}
            </ThemedMain>
        </ThemeContext.Provider>
    </React.Fragment>
);

PublicLayout.propTypes = {
    headerContent: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    mainContent: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

PublicLayout.defaultProps = {
    headerContent: null,
    mainContent: null,
};

function withPublicLayout(Component) {
    return (props) => {
        const content = (<Component {...props} />);

        return (
            <PublicLayout
                mainContent={content}
            />
        );
    };
}

export default withPublicLayout;
